import { render, staticRenderFns } from "./SelfReferral.vue?vue&type=template&id=602eea91&scoped=true&"
import script from "./SelfReferral.vue?vue&type=script&lang=ts&"
export * from "./SelfReferral.vue?vue&type=script&lang=ts&"
import style0 from "./SelfReferral.vue?vue&type=style&index=0&id=602eea91&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602eea91",
  null
  
)

export default component.exports